import React, { useEffect, useState, useContext, useRef } from 'react';
import FormContext from '../../helpers/formContext';
import RenderErrors from '../elements/RenderErrors';
import helpers from '../../helpers/helpers';

export default function PaymentSchedules({
    // payment_frequency,
    // payment_method,
    // payment_type
}){
    const {
        inputChange,
        helpers,
        form_data,
        site_options,
        errors,
        RenderErrors
    } = useContext(FormContext);
        const [schedule_list, setScheduleList] = useState([]);
        const [selected_payment_frequency, setPaymentFrequency] = useState(1);

        useEffect(() => {
            //console.log('PaymentSchedules called')
            //console.log('PaymentSchedules triggered!')
        }, []);

        useEffect(() => {
            // Normalize inputs once
            const paymentFrequencyInput = Number(form_data.payment_frequency);
            const paymentType = Number(form_data.payment_type);
            const paymentMethod = Number(form_data.payment_method);
            const preloadMethod = helpers.getURLParams('method'); // already a string

            let paymentFrequency = paymentFrequencyInput;

            if (paymentFrequency === 1) {
                if (paymentType === 1) {
                    paymentFrequency = 1; // One-time
                } else if (paymentType === 2) {
                    paymentFrequency = 2; // Monthly

                    // Quarterly conditions
                    const isQuarterlyMethod = [3, 4].includes(paymentMethod);
                    const isQuarterlyPreload = ['gcash', 'other'].includes(preloadMethod);

                    if (isQuarterlyMethod || isQuarterlyPreload) {
                    paymentFrequency = 3; // Quarterly
                    }
                }
            }

            setPaymentFrequency(paymentFrequency);

            const methods = site_options.payment_methods;
            const payment_methods = helpers.filterObject(methods, paymentMethod)
            const schedules = payment_methods?.payment_schedules //Payment Type Visibility
            setScheduleList(schedules)

            // const methods = site_options.payment_methods;
            // const selected_payment_method = parseInt(form_data.payment_method);
            // const payment_methods = helpers.filterObject(methods, selected_payment_method)
            // console.log('payment_methods_data', payment_methods)
            // const schedules = payment_methods?.payment_schedules //Payment Type Visibility
            // console.log('schedules', schedules)
            // setScheduleList(schedules)
        
            // let payment_frequency = parseInt(form_data.payment_frequency)

            // if(payment_frequency === 1){
            //     if(parseInt(form_data.payment_type) === 1){
            //         payment_frequency = 1 // One-time
            //     }
            //     else if(parseInt(form_data.payment_type) === 2){
            //         payment_frequency = 2 // Monthly

            //         if(parseInt(form_data.payment_method) === 3 || parseInt(form_data.payment_method) === 4){
            //             payment_frequency = 3 // Quarterly
            //         }

            //         const preload_method = helpers.getURLParams('method')
            //         if(parseInt(preload_method) === 'gcash' || parseInt(preload_method) === 'other'){
            //             payment_frequency = 3 // Quarterly
            //         }
            //     }
            // }
            // setPaymentFrequency(payment_frequency)

        }, [form_data]);

        if(parseInt(form_data.payment_type) === 1) return;

        return (     
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h3 className='fs-5'>Schedule</h3>
                    <span className="rbuttons4 d-lg-flex justify-content-start flex-nowrap gap-2">
                        {schedule_list.map((data) => {
                            let is_selected = '';
                            if(selected_payment_frequency === data.id){
                                is_selected = ' selected';
                            }

                            return (
                            <span className="rb-list-item" key={data.id}>
                                <input type="radio" name="payment_frequency" value={data.id} checked={is_selected} onChange={inputChange} />
                                <span className={`rb-list-label${is_selected}`}>{helpers.ucwords(data.text)}</span>
                            </span>
                            )
                        })}
                    </span>
                    <RenderErrors 
                        errors={errors} 
                        name="payment_frequency"
                        className="text-error fs-7"
                    />
                </div>  
            </div>   
        )
}